const getHtmlElement = () => {
  let $html = document.querySelector('html')

  return $html
}

class HtmlClassnames {
  static add = (names) => {
    const $html = getHtmlElement()

    $html.classList.add(names)
  }

  static remove = (names) => {
    const $html = getHtmlElement()

    $html.classList.remove(names)
  }

  static toggle = (names) => {
    const $html = getHtmlElement()

    $html.classList.toggle(names)
  }
}

export default HtmlClassnames



// WEBPACK FOOTER //
// ./src/js/utils/htmlClassnames.js